module.exports = __webpack_public_path__ + "Server-Default.TentaclePassive.43b409738b028a0d9457393a5f23a868.hashedasset.svg";